<template>
  <div>
    <br />
    <v-card v-if="information" color="primary-light" class="pa-3 my-2 d-flex">
      <div>
        <v-icon class="pa-2 mr-2"> $iconClipboard </v-icon>
      </div>
      <div>
        {{ $t("horses:HorseProfilePage.Sanctions.explanationText") }}
      </div>
    </v-card>
    <SanctionsTable
      :loading="$apollo.queries.sanctions.loading"
      :headers="headers"
      :sanctions="sanctions"
      :horse-id="horse.id"
      sanctioned-entity="Horse"
      refetch-query-name="horse"
    />
  </div>
</template>
<script>
import gql from "fraql";
import i18next from "i18next";
import SanctionsTable from "@elements/sanctions/SanctionsTable.vue";
export default {
  name: "HorseSanctions",
  components: { SanctionsTable },
  props: {
    horse: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      sanctions: []
    };
  },
  computed: {
    information() {
      return i18next.exists(
        "horses:HorseProfilePage.Sanctions.explanationText"
      );
    },
    headers() {
      return [
        {
          title: this.$t(
            "horses:HorseProfilePage.Sanctions.validityPeriod.label",
            "Time"
          ),
          sortable: false
        },
        {
          title: this.$t(
            "horses:HorseProfilePage.Sanctions.name.label",
            "Name"
          ),
          sortable: false
        },
        {
          title: this.$t(
            "horses:HorseProfilePage.Sanctions.description.label",
            "Description"
          ),
          sortable: false
        }
      ];
    }
  },
  apollo: {
    sanctions: {
      query: gql`
        query horseSanctions($id: ID) {
          horse(id: $id) {
            id
            sanctions {
              ${SanctionsTable.fragments.sanctionFields}
            }
          }
        }
      `,
      update: ({ horse }) => horse.sanctions,
      variables() {
        return {
          id: this.horse.id
        };
      }
    }
  }
};
</script>
